import { CategoryType } from 'types/category'
import { useEffect } from 'react'
import { fetchEnabledCategories } from 'reducks/category/operations'
import { useDispatch, useSelector } from 'react-redux'
import { State } from 'index'
import { getCategories } from 'reducks/category/selectors'

const useFetchCategories = (): CategoryType[] => {
  const dispatch = useDispatch()
  const categories = useSelector((state: State) => getCategories(state))
  useEffect(() => {
    dispatch(fetchEnabledCategories())
  }, [])
  return categories
}

export default useFetchCategories
